import { Component } from "@angular/core";
import { Router } from '@angular/router';

@Component({
    templateUrl: "./layout.component.html",
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {

    currentPage: any;
    bgColor = '';

    constructor(
        private router: Router
    ){
    }
    
    onActivate(event) {
        window.scrollTo(0, 0);
        if (this.getUrl() == 'home') this.currentPage = 'home';
        if (this.getUrl() == 'corporate-awards') {
            this.currentPage = 'corporateAwards';
            this.bgColor = 'corporate-awards-bg';
        }
        if (this.getUrl() == 'individual-awards') {
            this.currentPage = 'individualAwards'
            this.bgColor = 'individual-awards-bg';
        };
        if (this.getUrl() == 'partner-with-us') this.currentPage = 'partnerWithUs';
    }

    ngOnInit() {
        $(document).ready(function () {
            $('html, body').scrollTop(0);

            $(window).on('load', function () {
                setTimeout(function () {
                    $('html, body').scrollTop(0);
                }, 0);
            });
        });
    }

    getUrl() {
        var url = this.router.url;
        url = url.substring(url.lastIndexOf('/') + 1);
        return url;
    }
}
